import styled from 'styled-components'

export const StyledClickableIcon = styled.div`
  display: flex;
  font-weight: lighter;
  svg {
    color: ${({ theme }) => theme.palette.primary[3]};
    font-size: 1.5rem;    
  }
  &.disabled {
    pointer-events: none;
    color: ${({ theme }) => theme.palette.grayscale[3]};
    svg {
      color: ${({ theme }) => theme.palette.grayscale[3]};
    }    
  }
  &:hover {
    svg { 
      color: ${({ theme }) => theme.button.backgroundColor}; 
    }
    span { border-bottom: 1px solid; }
    cursor: pointer;
  }
`
